/**
 * Ottiene il vero URL web dell'applicazione
 * Risolve il problema di Capacitor che restituisce "capacitor://localhost"
 */

import { Capacitor } from '@capacitor/core';

// URL web dell'applicazione (da usare per condivisioni social su mobile)
const WEB_URL = 'https://www.wishareapp.com';

/**
 * Ottiene il dominio web corretto per la condivisione
 * @returns {string} - Il dominio web corretto
 */
export function getWebOrigin() {
  // Su piattaforme native (iOS/Android), usa sempre il dominio web fisso
  if (Capacitor.isNativePlatform()) {
    console.log('🔧 Piattaforma nativa rilevata, uso:', WEB_URL);
    return WEB_URL;
  }
  
  // Per web (http/https) usa l'origin corrente
  console.log('🌐 Piattaforma web rilevata, uso:', window.location.origin);
  return window.location.origin;
}

/**
 * Genera il link di condivisione per una wishlist
 * @param {string} wishlistId - ID della wishlist
 * @returns {string} - URL completo di condivisione
 */
export function getShareableWishlistUrl(wishlistId) {
  return `${getWebOrigin()}/shared/${wishlistId}`;
}
